import React from 'react';

export default function Refresh2Icon({
  width = 19,
  height = 19,
  fill = '#918F8F',
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.59693 3.82447C5.91167 2.68766 7.62552 2 9.5 2C13.6421 2 17 5.35786 17 9.5C17 11.1021 16.4976 12.5869 15.6419 13.8055L13.25 9.5H15.5C15.5 6.18629 12.8137 3.5 9.5 3.5C7.88736 3.5 6.42333 4.1362 5.34517 5.17131L4.59693 3.82447ZM14.403 15.1756C13.0883 16.3123 11.3745 17 9.5 17C5.35786 17 2 13.6421 2 9.5C2 7.89789 2.50234 6.41312 3.3581 5.19458L5.75 9.5H3.5C3.5 12.8137 6.18629 15.5 9.5 15.5C11.1126 15.5 12.5767 14.8638 13.6549 13.8287L14.403 15.1756Z"
        fill={fill}
      />
    </svg>
  );
}
